package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_03_10_Day_1
import com.veldekar.components.logs.Log_2023_03_10_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-03-10")
@Composable
public fun Log_2023_03_10(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Falorn Joins and Ankhegs Rise",
        ogTitle = "Falorn Joins and Ankhegs Rise",
        date = LocalDate(2_023, 3, 10),
        ogDescription = "Falorn joins the party as they embark toward Dorb, only to be ambushed by a massive Ankheg monstrosity.",
        ogImage = "ai/2023-03-10.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-17", dateString = "Newgrowth 17")
        Log_2023_03_10_Day_1()
        SessionDayHeader(dayId = "newgrowth-18", dateString = "Newgrowth 18")
        Log_2023_03_10_Day_2()
    }
}
